@if (isLoaded) {
<div class="notifications component">
  <div class="description-email-wrapper">
    <p class="description">
      Choose a notification delivery method for alerts, blogs, model and product
      updates. You can be notified on the website or via email.
    </p>
    @if (notificationEmails$ | async; as notificationEmailsList) {
    <div class="emails-wrapper">
      @for (email of notificationEmailsList; track email; let i = $index) {
      <span class="email">
        <firebird-web-notification-email
          [email]="email.email"
          [emailNumber]="i"
          [isAddAllowed]="notificationEmailsList.length === 1"
        >
        </firebird-web-notification-email>
      </span>
      }
    </div>
    }
    <div class="separator"></div>
    <div class="temp"></div>
    <div>
      <form [formGroup]="notificationForm" class="notification-form">
        <div class="column1">
          <div class="checkbox-header">
            <p class="label">Web</p>
            <p class="label">Email</p>
          </div>
          @if (alerts.length > 0) {
          <div>
            <div class="row-wrapper">
              <label class="label">Alerts</label>
              <div class="checkbox-select-all-wrapper">
                <div class="select-all-with-checkbox">
                  <span class="label-select-all">Select All</span>
                  <input
                    type="checkbox"
                    value="selectAllApp"
                    [checked]="isAllInAppAlert"
                    (change)="selectAll(alerts, $event, 'Alerts')"
                  />
                </div>
                <input
                  type="checkbox"
                  value="selectAllEmail"
                  [checked]="isAllEmailAlert"
                  (change)="selectAll(alerts, $event, 'Alerts')"
                />
              </div>
            </div>
            <div class="separator"></div>
            @for (control of alerts; track control) {
            <div class="row-wrapper">
              <label class="label">{{ control.displayName }}</label>
              <div
                class="checkbox-wrapper"
                [formArrayName]="control.notificationGroup || ''"
              >
                @for ( _ of $any(
                notificationForm.controls[control.notificationGroup || '']
                ).controls; track _; let i = $index) {
                <input
                  type="checkbox"
                  [value]="control.notificationGroup"
                  [formControlName]="i"
                  (change)="selectCheckboxAlert(i, $event)"
                />
                }
              </div>
            </div>
            }
          </div>
          } @if (blogs.length > 0) {
          <div>
            <div class="row-wrapper select-all-block">
              <label class="label">AG2 Forecaster Blogs</label>
              <div class="checkbox-select-all-wrapper">
                <div class="select-all-with-checkbox">
                  <span class="label-select-all">Select All</span>
                  <input
                    type="checkbox"
                    value="selectAllApp"
                    [checked]="isAllInAppBlog"
                    (change)="selectAll(blogs, $event, 'Blogs')"
                  />
                </div>
                <input
                  type="checkbox"
                  value="selectAllEmail"
                  [checked]="isAllEmailBlog"
                  (change)="selectAll(blogs, $event, 'Blogs')"
                />
              </div>
            </div>
            <div class="separator"></div>
            @for (control of blogs; track control) {
            <div class="row-wrapper">
              <label class="label">{{ control.displayName }}</label>
              <div
                class="checkbox-wrapper"
                [formArrayName]="control.notificationGroup || ''"
              >
                @for ( _ of $any(
                notificationForm.controls[control.notificationGroup || '']
                ).controls; track _; let i = $index) {
                <input
                  type="checkbox"
                  [value]="control.notificationGroup"
                  [formControlName]="i"
                  (change)="selectCheckboxBlog(i, $event)"
                />
                }
              </div>
            </div>
            }
          </div>
          } @if (startEndTimes.length > 0) {
          <div>
            <div class="row-wrapper select-all-block">
              <label class="label">Start and End Time</label>
              <div class="checkbox-select-all-wrapper">
                <div class="select-all-with-checkbox">
                  <span class="label-select-all">Select All</span>
                  <input
                    type="checkbox"
                    value="selectAllApp"
                    [checked]="isAllInAppStartEnd"
                    (change)="
                      selectAll(startEndTimes, $event, 'StartAndEndTime')
                    "
                  />
                </div>
                <input
                  type="checkbox"
                  value="selectAllEmail"
                  [checked]="isAllEmailStartEnd"
                  (change)="selectAll(startEndTimes, $event, 'StartAndEndTime')"
                />
              </div>
            </div>
            <div class="separator"></div>
            @for (control of startEndTimes; track control) {
            <div class="row-wrapper">
              <label class="label">{{ control.displayName }}</label>
              <div
                class="checkbox-wrapper"
                [formArrayName]="control.notificationGroup || ''"
              >
                @for ( _ of $any(
                notificationForm.controls[control.notificationGroup || '']
                ).controls; track _; let i = $index) {
                <input
                  type="checkbox"
                  [value]="control.notificationGroup"
                  [formControlName]="i"
                  (change)="selectCheckboxStartEnd(i, $event)"
                />
                }
              </div>
            </div>
            }
          </div>
          }
        </div>
        @if (notifications.length > 0) {
        <div class="column2">
          <div class="checkbox-header">
            <p class="label">Web</p>
            <p class="label">Email</p>
          </div>
          <div class="row-wrapper">
            <label class="label">Product Updated</label>
            <div class="checkbox-select-all-wrapper">
              <div class="select-all-with-checkbox">
                <span class="label-select-all">Select All</span>
                <input
                  type="checkbox"
                  value="selectAllApp"
                  [checked]="isAllInAppNotifications"
                  (change)="selectAll(notifications, $event, 'Notifications')"
                />
              </div>
              <input
                type="checkbox"
                value="selectAllEmail"
                [checked]="isAllEmailNotifications"
                (change)="selectAll(notifications, $event, 'Notifications')"
              />
            </div>
          </div>
          <div class="separator"></div>
          @for (control of notifications; track control) {
          <div class="row-wrapper">
            <label class="label">{{ control.displayName }}</label>
            <div
              class="checkbox-wrapper"
              [formArrayName]="control.notificationGroup || ''"
            >
              @for ( _ of $any(
              notificationForm.controls[control.notificationGroup || '']
              ).controls; track _; let i = $index) {
              <input
                type="checkbox"
                [value]="control.notificationGroup"
                [formControlName]="i"
                (click)="disableCheckbox($event, control, i)"
                [ngClass]="{ disabled: !control.isClickable && i === 0 }"
                (change)="selectCheckboxNotification(i, $event)"
              />
              }
            </div>
          </div>
          }
        </div>
        }
      </form>
    </div>
  </div>
</div>
} @else {
<div class="loader">
  <firebird-web-loader></firebird-web-loader>
</div>
}
